import en from './en.json';
import kn from './kn.json';
    export const changeLanguage = (language,title) => {
// console.log('siteLanguage',language,'',title)
    if(language === 'kn'){
        return kn[title];
    }else{
        return en[title];
    }
  }